import {createInterceptors} from './createInterceptors';
import {lifeCycleFnsToHandlers} from './lifeCycleFnsToHandlers';
import {mergeBehaviorActionHandlers} from './mergeBehaviorActionHandlers';
import {mergeBehaviorInitialState} from './mergeBehaviorInitialState';
import {mergeBehaviorProperties} from './mergeBehaviorProperties';
import {mergeLifeCycleActionHandlers} from './mergeLifeCycleActionHandlers';
import {normalizeActionHandlers} from './normalizeActionHandlers';
import {normalizeActionHandler} from './normalizeActionHandler';
import {normalizeBehaviors} from './normalizeBehaviors';
import {getStopPropagation} from './getStopPropagation';
import {mergeActions} from './mergeActions';
import {mergeEventActionHandlers} from './mergeEventActionHandlers';
import {applyPayloadValidators} from './applyPayloadValidators';
import {mergeBehaviorActions} from './mergeBehaviorActions';
import {getActionsToDispatch} from './getActionsToDispatch';
import {normalizeBehaviorEventHandlers} from './normalizeBehaviorEventHandlers';
import {SHADOW_ROOT_MODE_OPEN, ARIA_LIVE_REGION_UPDATE_REQUESTED} from '../../constants';
import {actionHandler as ariaLiveRegionActionHandler} from '../../accessibility/ariaLiveRegion';

export function normalizeConfig(config) {
	const {
		eventHandlers: componentEventHandlers = [],
		actionHandlers = {},
		behaviors = [],
		properties = {},
		name,
		initialState,
		setInitialState,
		actions = {},
		shadowRootOptions: {mode: shadowRootMode = SHADOW_ROOT_MODE_OPEN} = {}
	} = config;

	const normalizedBehaviors = normalizeBehaviors(behaviors, name);
	const eventHandlers = [
		...componentEventHandlers,
		...normalizeBehaviorEventHandlers(normalizedBehaviors)
	];
	const mergedActionHandlers = mergeEventActionHandlers(
		mergeBehaviorActionHandlers(
			normalizedBehaviors,
			mergeActions(
				mergeLifeCycleActionHandlers(
					lifeCycleFnsToHandlers(
						[config, ...normalizedBehaviors.map(({behavior}) => behavior)],
						name
					),
					normalizeActionHandlers(actionHandlers, name)
				),
				actions,
				name
			)
		),
		eventHandlers,
		name
	);

	mergedActionHandlers[ARIA_LIVE_REGION_UPDATE_REQUESTED] = [
		normalizeActionHandler(ariaLiveRegionActionHandler)
	];

	const interceptors = createInterceptors(mergedActionHandlers);
	const mergedInitialStates = mergeBehaviorInitialState(
		normalizedBehaviors,
		initialState,
		setInitialState,
		name
	);

	return {
		shouldDispatch: getActionsToDispatch(interceptors),
		eventHandlers,
		shouldStopPropagation: getStopPropagation(mergedActionHandlers),
		actions: applyPayloadValidators(mergeBehaviorActions(actions, normalizedBehaviors, name)),
		actionTypes: {}, // TODO: add action data types for validation
		initialState: mergedInitialStates.initialState,
		setInitialState: mergedInitialStates.setInitialState,
		properties: mergeBehaviorProperties(normalizedBehaviors, properties, name),
		interceptors,
		behaviors: normalizedBehaviors,
		shadowRootOptions: {
			mode: shadowRootMode
		}
	};
}
